<div [hidden]="isExpanded" (click)="expandEditor()" class="folded-editor">
  <div class="textarea-and-send-button">
    <textarea
      rows="1"
      disabled
      placeholder="{{ textareaPlaceholder }}"
      [ngClass]="{ 'blue-placeholder': isTextAreaBluePlaceholder }"
      class="alc-editor-textarea"
      (click)="$event.stopPropagation()"></textarea>
    <ion-button disabled fill="clear" class="tpp-send-icon-button">
      <ion-icon slot="icon-only" name="send-sharp"></ion-icon>
    </ion-button>
    <div class="tpp-textual-send-buttons-container">
      <ion-button disabled>
        {{ 'm/task-process/send' | translate }}
      </ion-button>
    </div>
  </div>
</div>
<div *ngIf="taskProcessContext.isProcessedTaskLoaded$ | async" [hidden]="!isExpanded" class="expanded-editor">
  <app-reply-in-as-to-line
    [class.whatsapp-template-reply]="isWhatsappTemplateMode"
    [isWhatsappTemplateMode]="isWhatsappTemplateMode"
    [taskProcessContext]="taskProcessContext"></app-reply-in-as-to-line>
  <div *ngFor="let message of singleMessages.messages" class="editor-and-send-buttons">
    <app-single-message-editor
      *ngIf="taskProcessContext.taskProcessPageWithScrollContainer !== undefined && !isWhatsappTemplateMode"
      [editorConfig]="taskProcessContext.editorConfig"
      [message]="message"
      [favorites]="filteredFavorites"
      [favoritesAllLang]="filteredFavoritesAllLang"
      [isReplyingInPrivate]="taskProcessContext.isReplyingInPrivate()"
      [scrollContainer]="taskProcessContext.taskProcessPageWithScrollContainer.scrollContainer"
      [siteId]="taskProcessContext.site.id"
      [taskProcessContext]="taskProcessContext">
    </app-single-message-editor>
    <app-choose-template-flow
      *ngIf="isWhatsappTemplateMode"
      [taskProcessContext]="taskProcessContext"
      [templates]="whatsappTemplates">
      <ng-container *ngTemplateOutlet="sendButtons"></ng-container>
    </app-choose-template-flow>

    <ng-container *ngIf="!isWhatsappTemplateMode">
      <ng-container *ngTemplateOutlet="sendButtons"></ng-container>
    </ng-container>

    <ng-template #sendButtons>
      <!-- send buttons, either an icon or two textual buttons -->
      <div
        [style.visibility]="message.isLast ? 'visible' : 'hidden'"
        [ngClass]="{ 'is-focused': message.isFocused }"
        class="send-buttons-column">
        <!-- send button for mobile mode: an "envelope" icon -->
        <ion-button
          (click)="onMobileSendClicked()"
          [disabled]="isSendButtonDisabled"
          fill="clear"
          class="tpp-send-icon-button">
          <ion-icon slot="icon-only" name="send-sharp"></ion-icon>
        </ion-button>

        <!-- "send" + "send and..." textual buttons for desktop mode -->
        <div class="tpp-textual-send-buttons-container">
          <ion-button data-testid="send-message" (click)="onDesktopSendClicked()" [disabled]="isSendButtonDisabled">
            {{ 'm/task-process/send' | translate }}
          </ion-button>
          <ion-button
            data-testid="send-and-transfer-message"
            (click)="onDesktopSendAndClicked($event)"
            [disabled]="isSendButtonDisabled"
            fill="outline">
            {{ 'm/task-process/send_and' | translate }}
          </ion-button>
        </div>
      </div>
    </ng-template>
  </div>
  <ion-button (click)="foldEditor()" expand="full" fill="clear" class="fold-button" data-testid="shrink-textarea">
    <ion-icon slot="icon-only" name="chevron-down"></ion-icon>
  </ion-button>
</div>
